import { createReducer, on } from '@ngrx/store';
import {DashboardSettingsState, Vestiging} from './dashboardsettings.state';
import { datumbereikenFetched, setVestigingen } from './dashboardsettings.actions';
import { findWithHighestDateAndSmallestPeriod } from '../../stateless/datumbereik';
import moment from 'moment';
import { Periode } from '../../services/datumbereik';

const initialState: DashboardSettingsState = {
    vestigingen: [],
    defaultVestiging: null,
    datumbereiken: [],
    defaultPeriode: 'WEEK',
    defaultEpochSeconds: moment().startOf('isoWeek').seconds()
};

export const dashboardSettingsReducer = createReducer(
    initialState,
    on(setVestigingen, (state, { value }) => ({
      ...state,
      vestigingen: value,
      defaultVestiging: (value.length > 0 ? findEersteVestigingMetData(value) : null)
    })),
    on(datumbereikenFetched, (state, { value }) => {
      const rangeWithHighestDateAndSmallestPeriod = findWithHighestDateAndSmallestPeriod(value, state.defaultEpochSeconds, state.defaultPeriode);
      if (!value || value.length === 0) {
        return {
          ...state,
          datumbereiken: [],
          defaultEpochSeconds: 0,
          defaultPeriode: initialState.defaultPeriode
        };
      }
      return {
        ...state,
        datumbereiken: value,
        defaultEpochSeconds: rangeWithHighestDateAndSmallestPeriod.epochSeconds,
        defaultPeriode: rangeWithHighestDateAndSmallestPeriod.periode
      };
    })
);

function findEersteVestigingMetData(vestigingen: Vestiging[]): Vestiging | undefined {
  return vestigingen.find(v => v.heeftData);
}
